import React from 'react'
import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

class LanguageButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeLang: this.props.activeLang
    }
    this.changeActive = this.changeActive.bind(this)
  }

  changeActive() {
    this.props.updateSelectedLang(this.props.myLang)
  }

  componentDidUpdate() {
    if (this.state.activeLang !== this.props.activeLang) {
      this.setState({activeLang: this.props.activeLang})
    }
  }

  render() {

    const LanguageButtonStyle = styled.span `
        border: solid 1px rgba(110,110,110, .35);
        background-color: rgba(110,110,110, .15);
        color: rgba(110,110,110, .35);

        &:hover {
          background-color: ${this.props.themeStyles.mainColor};
          border: solid 1px ${this.props.themeStyles.mainColor};
          color: white;
        }

        &.active {
          background-color: rgba(110,110,110,0.75);
          border: solid 1px rgba(110,110,110,0.85);
          color: white;
        }
        `

    if (this.state.activeLang === this.props.myLang) {
      return (<LanguageButtonStyle className="languageButton active" onClick={this.changeActive}>
        {this.props.myLang}
      </LanguageButtonStyle>)
    } else {
      return (<LanguageButtonStyle className="languageButton" onClick={this.changeActive}>
        {this.props.myLang}
      </LanguageButtonStyle>)
    }
  }
}

export default LanguageButton
